<template lang="html">
    <div>
        <div class="breadCrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>{{$t('message.users')}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- <div> -->
        <div class="flex-row second-tip">
            <div class="title"></div>
            <div class="flex-row search-container">
                <el-input class="appManagement-search"
                :placeholder="$t('message.enterAccount')"
                v-model="accountInfo"  @keyup.enter.native="searchAccount" clearable>
            </el-input>
            <el-button  class="search-btn" icon="el-icon-search" @click="searchAccount"></el-button>
            <router-link :to="{path:'/adminAdd/nil'}"><el-button type="primary" class="verifone-btn" plain icon="el-icon-plus">{{$t('message.add')}}</el-button></router-link>
        </div>
    </div>
    <div class="verifone-panel">
        <div class="appManagement-table-main btn-table">
            <template>
                <el-table :data="accountList" style="width: 100%">
                    <el-table-column prop="username" :label="$t('message.accountName')" :show-overflow-tooltip="true" width="400"></el-table-column>
                    <el-table-column prop="name" :label="$t('message.name')" :show-overflow-tooltip="true" ></el-table-column>
                    <el-table-column prop="date" :label="$t('message.date')" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop=""  :label="$t('message.operation')" width="210" align="center">
                        <template slot-scope="scope">
                            <!-- <img class="delete-btn" src="static/img/delete.png" alt="" @click="showAdminDeleteDialog(scope.row)"> -->
                            <el-button class="verifone-btn" type="success" plain icon="el-icon-edit" @click="handleModify(scope.row)">{{$t('message.edit')}}</el-button>
                            <el-button class="verifone-btn" type="danger" plain icon="el-icon-close" @click="handleDelete(scope.row)">{{$t('message.delete')}}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <div class="pagination-main">
                <el-pagination  background layout="prev, pager, next" :page-count="totalPage" @current-change="handleCurrentChange" :current-page="adminNum"></el-pagination>
            </div>
        </div>

    </div>
    <el-dialog title="Add Subordinate" :visible.sync="addAdminDialogVisible" width="30%" class="adminAdd-dialog">
        <div>
            <div class="edit-item">
                <span><i class="redStar">*</i>Name</span>
                <el-input class="addAdminInput" v-model="username" type="text"></el-input>
            </div>
            <div class="edit-item">
                <span><i class="redStar">*</i>Password</span>
                <el-input class="addAdminInput" v-model="password" type="password"></el-input>
            </div>
            <div class="edit-item">
                <span><i class="redStar">*</i>Password Again</span>
                <el-input class="addAdminInput" v-model="copyPassword" type="password"></el-input>
            </div>
            <div class="edit-item">
                <span><i class="redStar">*</i>E-mail</span>
                <el-input class="addAdminInput" v-model="emailInput" type="text"></el-input>
            </div>
            <div class="edit-item">
                <span><i class="redStar">*</i>Type</span>
                <el-select class="addAdminInput" v-model="role" placeholder="" style="width: 200px">
                    <el-option v-for="item in options" :key="item.value" :label="item.valueKey" :value="item.value">
                        <img :src="item.label"><span>{{item.valueKey}}</span>
                    </el-option>
                </el-select>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="addAdminDialogVisible = false">Cancel</el-button>
            <el-button type="success" @click="addAccount">OK</el-button>
        </span>
    </el-dialog>
    <el-dialog title="" :visible.sync="deleteDialogVisible" custom-class="tips-dialog" class="quit-dialog warn-dialog">
        <div class="warn-container flex-row">
            <img class="warn-icon" alt="" src="static/img/alertWarn.png">
            <span>&nbsp;&nbsp;{{$t('message.warn')}}</span>
        </div>
        <div class="dialog-body">
            <span>{{$t('message.deleteUser')}}</span><span>{{deleteName}}</span><span>"?</span>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button class="verifone-btn" type="primary" plain @click="deleteDialogVisible = false">{{$t('message.no')}}</el-button>
            <el-button class="verifone-btn" type="primary" @click="deleteAccount">{{$t('message.yes')}}</el-button>
        </span>
    </el-dialog>
</div>
</template>
<script>
export default {
    data() {
        return {
            accountResearch:0,//0 为account 1为输入查询
            accountInfo:'',
            role:1,
            username:'',
            password:'',
            copyPassword:'',
            emailInput:'',
            adminNum:1,
            accountList:[],
            totalPage:1,
            options: [{
                value: 1,
                label: 'static/img/favicon.png',
                valueKey: 'china'
            }, {
                value: 2,
                label: 'static/img/favicon.png',
                valueKey: 'china-x'
            }, {
                value: 3,
                label: 'static/img/favicon.png',
                valueKey: 'china-c'
            }],
            deleteName: '',
            editDialogVisible: false,
            deleteDialogVisible: false,
            addAdminDialogVisible: false,
            inputCheck: this.$t('message.inputCheck'),
            emailCheck: this.$t('message.emailCheck'),
            deleteSuccess: this.$t('message.deleteSuccess')
        }
    },
    mounted() {
        this.queryAccountList();
    },
    methods: {
        handleModify(row) {
            this.$router.replace('/adminAdd/' + row.id);
        },
        handleDelete(row) {
            this.deleteName = row.username;
            this.deleteDialogVisible = true;
        },
        handleCurrentChange(val) {
            this.adminNum = val;
            if(this.accountResearch == 0) {
                this.queryAccountList();
            }
            else if(this.accountResearch == 1) {
                this.searchAccount();
            }
            console.log('当前页: '+val);
        },
        queryAccountList() {
            const that = this;

            let obj = {
                pageNum:this.adminNum
            };

            this.$axios({
                method: 'post',
                url: '/marketplace/admin/account/page',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    that.accountResearch=0;
                    that.accountList = response.data.accountList;
                    that.totalPage = response.data.totalPage;
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        deleteAccount() {
            const that = this;

            let obj = {
                username:this.deleteName
            };

            this.$axios({
                method: 'post',
                url: '/marketplace/admin/account/delete',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    that.$message({
                    type: "success",
                    message: that.deleteSuccess,
                    duration:'3000',
                    });
                    that.deleteDialogVisible = false;
                    that.queryAccountList();
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        addAccount() {
            if(this.username ===""){
                this.$message({
                    type: "error",
                    message: this.inputCheck,
                    duration:'3000',
                });
                return;
            }
            if(this.password ===""){
                this.$message({
                    type: "error",
                    message: this.inputCheck,
                    duration:'3000',
                });
                return;
            }
            if(this.copyPassword ===""){
                this.$message({
                    type: "error",
                    message: this.inputCheck,
                    duration:'3000',
                });
                return;
            }
            if(this.password != this.copyPassword){
                this.$message({
                    type: "error",
                    message: this.inputCheck,
                    duration:'3000',
                });
                return;
            }
            if(!this.checkEmail()){
                return;
            }
            const that=this;

            let obj = {
                username:this.username,
                password:this.password,
                email:this.emailInput,
                role:this.role
            };

            this.$axios({
                method: 'post',
                url: '/marketplace/admin/account/add',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    that.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    that.addAdminDialogVisible = false;
                    that.adminNum=1;
                    that.queryAccountList();
                    that.username='';
                    that.password='';
                    that.emailInput='';
                    that.role='';
                    that.copyPassword='';
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        searchAccount() {
            let obj = {
                pageNum:this.adminNum,
                info:this.accountInfo
            };

            this.$axios({
                method: 'post',
                url: '/marketplace/admin/account/search',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    this.accountResearch = 1;
                    this.accountList = response.data.accountList;
                    this.totalPage = response.data.totalPage;
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        handleClick(row) {
            this.deleteTipVisible = true;
            console.log(row);
            console.log(row.date,row.name);
        },
        showAdminDeleteDialog(row) {
            this.deleteTipVisible = true;
            this.deleteName = row.username;
        },
        checkEmail(){
            const emailParten=/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
            if(emailParten.test(this.emailInput)){
                return true;
            }else {
                this.$message({
                    type: "error",
                    message: this.emailCheck,
                    duration:'3000',
                });
                return false;
            }

        }

    }

}
</script>

<style lang="css" scoped="scope">
.appManagement-container {
    overflow: hidden;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    width: 100%;
}
.appManagement-table {
    width:100%;
    padding:10px 30px;
}
.appManagement-table-main {
    padding: 20px;
    background-color: #fff;
}
.pagination-main {
    /*margin-top: 20px;*/
    padding:30px 0 10px 0;
    background: #fff;
    width: 100%;
}
.appManagement-search .el-input__inner {
    border-radius: 20px;
}
/* .search-container {
padding-right: 100px;
} */
.appManagement-search {
    width: 400px;
    border-radius: 20px;
    margin-right: 10px;
}
.edit-item {
    justify-content: flex-start
}
.edit-item >span {
    text-align: right;
    margin-right: 15px;
    width:120px!important;
}
.addAdminInput {
    width:200px
}
.addApp-btn {
    background: #58D56D;
    color: #fff;
}
.breadCrumb-container {
    width: 100%;
}
.delete-btn {
    width: 20px;
    height: 20px;
}
.redStar {
    color: red;
    font-size: 20px;
    font-weight: bold;
    margin-top: 5px;
    margin-right: 10px;
    position: relative;
    top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/AdminList.vue